import { ReactNode } from "react";
import { useTranslations } from "@jugl-web/utils";
import { NavigationPage } from "@web-src/modules/navigation/hooks/useNavigation";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";

import { ReactComponent as TaskTitleIcon } from "./assets/tasks/title-icon.svg";
import taskInfoImage from "./assets/tasks/info-image.jpg";
import taskHighlightsImage from "./assets/tasks/highlights-image.png";
import { ReactComponent as TaskFeature1Icon } from "./assets/tasks/feature-list-item-1.svg";
import { ReactComponent as TaskFeature2Icon } from "./assets/tasks/feature-list-item-2.svg";
import { ReactComponent as TaskFeature3Icon } from "./assets/tasks/feature-list-item-3.svg";
import { ReactComponent as TaskFeature4Icon } from "./assets/tasks/feature-list-item-4.svg";
import { ReactComponent as TaskFeature5Icon } from "./assets/tasks/feature-list-item-5.svg";
import { ReactComponent as TaskFeature6Icon } from "./assets/tasks/feature-list-item-6.svg";

import { ReactComponent as ChatsAndMeetingsTitleIcon } from "./assets/chatsAndMeetings/title-icon.svg";
import chatsAndMeetingsInfoImage from "./assets/chatsAndMeetings/info-image.jpg";
import chatsAndMeetingsHighlightsImage from "./assets/chatsAndMeetings/highlights-image.png";
import chatsVideoThumbnailImage from "./assets/chatsAndMeetings/video-thumbnail.png";
import { ReactComponent as ChatsAndMeetingsFeature1Icon } from "./assets/chatsAndMeetings/feature-list-item-1.svg";
import { ReactComponent as ChatsAndMeetingsFeature2Icon } from "./assets/chatsAndMeetings/feature-list-item-2.svg";
import { ReactComponent as ChatsAndMeetingsFeature3Icon } from "./assets/chatsAndMeetings/feature-list-item-3.svg";
import { ReactComponent as ChatsAndMeetingsFeature4Icon } from "./assets/chatsAndMeetings/feature-list-item-4.svg";
import { ReactComponent as ChatsAndMeetingsFeature5Icon } from "./assets/chatsAndMeetings/feature-list-item-5.svg";

import { ReactComponent as DashboardTitleIcon } from "./assets/dashboard/title-icon.svg";
import dashboardInfoImage from "./assets/dashboard/info-image.jpg";
import dashboardHighlightsImage from "./assets/dashboard/highlights-image.png";
import { ReactComponent as DashboardFeature1Icon } from "./assets/dashboard/feature-list-item-1.svg";
import { ReactComponent as DashboardFeature2Icon } from "./assets/dashboard/feature-list-item-2.svg";
import { ReactComponent as DashboardFeature3Icon } from "./assets/dashboard/feature-list-item-3.svg";
import { ReactComponent as DashboardFeature4Icon } from "./assets/dashboard/feature-list-item-4.svg";
import { ReactComponent as DashboardFeature5Icon } from "./assets/dashboard/feature-list-item-5.svg";

import { ReactComponent as WhatsAppIntegrationTitleIcon } from "./assets/whatsAppIntegration/title-icon.svg";
import whatsAppIntegrationInfoImage from "./assets/whatsAppIntegration/info-image.jpg";
import whatsAppIntegrationHighlightsImage from "./assets/whatsAppIntegration/highlights-image.png";
import { ReactComponent as WhatsAppIntegrationFeature1Icon } from "./assets/whatsAppIntegration/feature-list-item-1.svg";
import { ReactComponent as WhatsAppIntegrationFeature2Icon } from "./assets/whatsAppIntegration/feature-list-item-2.svg";
import { ReactComponent as WhatsAppIntegrationFeature3Icon } from "./assets/whatsAppIntegration/feature-list-item-3.svg";
import { ReactComponent as WhatsAppIntegrationFeature4Icon } from "./assets/whatsAppIntegration/feature-list-item-4.svg";
import { ReactComponent as WhatsAppIntegrationFeature5Icon } from "./assets/whatsAppIntegration/feature-list-item-5.svg";

import { ReactComponent as FormsTitleIcon } from "./assets/forms/title-icon.svg";
import formsInfoImage from "./assets/forms/info-image.jpg";
import formsHighlightsImage from "./assets/forms/highlights-image.png";
import { ReactComponent as FormsFeature1Icon } from "./assets/forms/feature-list-item-1.svg";
import { ReactComponent as FormsFeature2Icon } from "./assets/forms/feature-list-item-2.svg";
import { ReactComponent as FormsFeature3Icon } from "./assets/forms/feature-list-item-3.svg";
import { ReactComponent as FormsFeature4Icon } from "./assets/forms/feature-list-item-4.svg";
import { ReactComponent as FormsFeature5Icon } from "./assets/forms/feature-list-item-5.svg";

import { ReactComponent as CustomersTitleIcon } from "./assets/customers/title-icon.svg";
import customersInfoImage from "./assets/customers/info-image.jpg";
import customersHighlightsImage from "./assets/customers/highlights-image.png";
import { ReactComponent as CustomersFeature1Icon } from "./assets/customers/feature-list-item-1.svg";
import { ReactComponent as CustomersFeature2Icon } from "./assets/customers/feature-list-item-2.svg";
import { ReactComponent as CustomersFeature3Icon } from "./assets/customers/feature-list-item-3.svg";
import { ReactComponent as CustomersFeature4Icon } from "./assets/customers/feature-list-item-4.svg";
import { ReactComponent as CustomersFeature5Icon } from "./assets/customers/feature-list-item-5.svg";

import { ReactComponent as ScheduledReportsTitleIcon } from "./assets/scheduledReports/title-icon.svg";
import scheduledReportsInfoImage from "./assets/scheduledReports/info-image.jpg";
import scheduledReportsHighlightsImage from "./assets/scheduledReports/highlights-image.png";
import { ReactComponent as ScheduledReportsFeature1Icon } from "./assets/scheduledReports/feature-list-item-1.svg";
import { ReactComponent as ScheduledReportsFeature2Icon } from "./assets/scheduledReports/feature-list-item-2.svg";
import { ReactComponent as ScheduledReportsFeature3Icon } from "./assets/scheduledReports/feature-list-item-3.svg";
import { ReactComponent as ScheduledReportsFeature4Icon } from "./assets/scheduledReports/feature-list-item-4.svg";
import { ReactComponent as ScheduledReportsFeature5Icon } from "./assets/scheduledReports/feature-list-item-5.svg";
import { ReactComponent as ScheduledReportsFeature6Icon } from "./assets/scheduledReports/feature-list-item-6.svg";

import { ReactComponent as DriveTitleIcon } from "./assets/drive/title-icon.svg";
import driveInfoImage from "./assets/drive/info-image.jpg";
import driveHighlightsImage from "./assets/drive/highlights-image.png";
import { ReactComponent as DriveFeature1Icon } from "./assets/drive/feature-list-item-1.svg";
import { ReactComponent as DriveFeature2Icon } from "./assets/drive/feature-list-item-2.svg";
import { ReactComponent as DriveFeature3Icon } from "./assets/drive/feature-list-item-3.svg";
import { ReactComponent as DriveFeature4Icon } from "./assets/drive/feature-list-item-4.svg";
import { ReactComponent as DriveFeature5Icon } from "./assets/drive/feature-list-item-5.svg";

import { ReactComponent as TravelLogTitleIcon } from "./assets/travelLog/title-icon.svg";
import travelLogInfoImage from "./assets/travelLog/info-image.jpg";
import travelLogHighlightsImage from "./assets/travelLog/highlights-image.png";
import { ReactComponent as TravelLogFeature1Icon } from "./assets/travelLog/feature-list-item-1.svg";
import { ReactComponent as TravelLogFeature2Icon } from "./assets/travelLog/feature-list-item-2.svg";
import { ReactComponent as TravelLogFeature3Icon } from "./assets/travelLog/feature-list-item-3.svg";
import { ReactComponent as TravelLogFeature4Icon } from "./assets/travelLog/feature-list-item-4.svg";
import { ReactComponent as TravelLogFeature5Icon } from "./assets/travelLog/feature-list-item-5.svg";
import { ReactComponent as TravelLogFeature6Icon } from "./assets/travelLog/feature-list-item-6.svg";

import { ReactComponent as CatalogTitleIcon } from "./assets/catalog/title-icon.svg";
import catalogInfoImage from "./assets/catalog/info-image.jpg";
import catalogHighlightsImage from "./assets/catalog/highlights-image.png";
import { ReactComponent as CatalogFeature1Icon } from "./assets/catalog/feature-list-item-1.svg";
import { ReactComponent as CatalogFeature2Icon } from "./assets/catalog/feature-list-item-2.svg";
import { ReactComponent as CatalogFeature3Icon } from "./assets/catalog/feature-list-item-3.svg";
import { ReactComponent as CatalogFeature4Icon } from "./assets/catalog/feature-list-item-4.svg";
import { ReactComponent as CatalogFeature5Icon } from "./assets/catalog/feature-list-item-5.svg";

import { ReactComponent as AIAgentsTitleIcon } from "./assets/aiAgents/title-icon.svg";
import aIAgentsInfoImage from "./assets/aiAgents/info-image.jpg";
import aIAgentsHighlightsImage from "./assets/aiAgents/highlights-image.png";
import aIAgentsVideoThumbnailImage from "./assets/aiAgents/video-thumbnail.png";
import { ReactComponent as AIAgentsFeature1Icon } from "./assets/aiAgents/feature-list-item-1.svg";
import { ReactComponent as AIAgentsFeature2Icon } from "./assets/aiAgents/feature-list-item-2.svg";
import { ReactComponent as AIAgentsFeature3Icon } from "./assets/aiAgents/feature-list-item-3.svg";
import { ReactComponent as AIAgentsFeature4Icon } from "./assets/aiAgents/feature-list-item-4.svg";
import { ReactComponent as AIAgentsFeature5Icon } from "./assets/aiAgents/feature-list-item-5.svg";

import { ReactComponent as IntegrationsTitleIcon } from "./assets/integrations/title-icon.svg";
import integrationsInfoImage from "./assets/integrations/info-image.jpg";
import integrationsHighlightsImage from "./assets/integrations/highlights-image.png";
import { ReactComponent as IntegrationsFeature1Icon } from "./assets/integrations/feature-list-item-1.svg";
import { ReactComponent as IntegrationsFeature2Icon } from "./assets/integrations/feature-list-item-2.svg";
import { ReactComponent as IntegrationsFeature3Icon } from "./assets/integrations/feature-list-item-3.svg";
import { ReactComponent as IntegrationsFeature4Icon } from "./assets/integrations/feature-list-item-4.svg";
import { ReactComponent as IntegrationsFeature5Icon } from "./assets/integrations/feature-list-item-5.svg";

import { ReactComponent as AutomationTitleIcon } from "./assets/automation/title-icon.svg";
import automationInfoImage from "./assets/automation/info-image.jpg";
import automationHighlightsImage from "./assets/automation/highlights-image.png";
import automationVideoThumbailImage from "./assets/automation/video-thumbnail.png";
import { ReactComponent as AutomationFeature1Icon } from "./assets/automation/feature-list-item-1.svg";
import { ReactComponent as AutomationFeature2Icon } from "./assets/automation/feature-list-item-2.svg";
import { ReactComponent as AutomationFeature3Icon } from "./assets/automation/feature-list-item-3.svg";
import { ReactComponent as AutomationFeature4Icon } from "./assets/automation/feature-list-item-4.svg";
import { ReactComponent as AutomationFeature5Icon } from "./assets/automation/feature-list-item-5.svg";
import { ReactComponent as AutomationFeature6Icon } from "./assets/automation/feature-list-item-6.svg";

import { ReactComponent as InvoicesTitleIcon } from "./assets/invoices/title-icon.svg";
import invoicesInfoImage from "./assets/invoices/info-image.jpg";
import invoicesHighlightsImage from "./assets/invoices/highlights-image.png";
import { ReactComponent as InvoicesFeature1Icon } from "./assets/invoices/feature-list-item-1.svg";
import { ReactComponent as InvoicesFeature2Icon } from "./assets/invoices/feature-list-item-2.svg";
import { ReactComponent as InvoicesFeature3Icon } from "./assets/invoices/feature-list-item-3.svg";
import { ReactComponent as InvoicesFeature4Icon } from "./assets/invoices/feature-list-item-4.svg";
import { ReactComponent as InvoicesFeature5Icon } from "./assets/invoices/feature-list-item-5.svg";
import { ReactComponent as InvoicesFeature6Icon } from "./assets/invoices/feature-list-item-6.svg";

import { ReactComponent as PeopleTitleIcon } from "./assets/people/title-icon.svg";
import peopleInfoImage from "./assets/people/info-image.png";
import { ReactComponent as PeopleFeature1Icon } from "./assets/people/feature-list-item-1.svg";
import { ReactComponent as PeopleFeature2Icon } from "./assets/people/feature-list-item-2.svg";
import { ReactComponent as PeopleFeature3Icon } from "./assets/people/feature-list-item-3.svg";
import { ReactComponent as PeopleFeature4Icon } from "./assets/people/feature-list-item-4.svg";
import { ReactComponent as PeopleFeature5Icon } from "./assets/people/feature-list-item-5.svg";
import { ReactComponent as PeopleFeature6Icon } from "./assets/people/feature-list-item-6.svg";

export type InfoStepType = {
  type: "info";
  description: string;
  imageUrl: string;
  points: { title: string; icon: ReactNode }[];
  navigateTo: NavigationPage;
};

export type VideoStepType = {
  type: "video";
  videoUrl: string;
  thumbnailUrl?: string;
};

export type HighlightsStepType = {
  type: "highlights";
  imageUrl: string;
};

type ModuleStepsTuple = [InfoStepType, VideoStepType, HighlightsStepType];

export const useWorkspaceFeatureInfo = () => {
  const { t } = useTranslations();

  const modulesData: Partial<
    Record<
      SubscriptionPlanModuleId,
      {
        title: string;
        titleIcon: ReactNode;
        steps: ModuleStepsTuple | Partial<ModuleStepsTuple>;
      }
    >
  > = {
    "Jugl::Task": {
      title: t({
        id: "workspace-features-page.module-info-tasks.title",
        defaultMessage: "Tasks",
      }),
      titleIcon: <TaskTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-tasks.description",
            defaultMessage:
              "Tasks help you manage everything from simple to-dos to multi-step processes across teams. It’s powerful enough for complex workflows, letting you assign tasks, set deadlines, track progress, and keep work moving without anything slipping through the cracks.",
          }),
          imageUrl: taskInfoImage,
          navigateTo: "tasksEntryPoint",
          points: [
            {
              icon: <TaskFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-tasks.feature-1",
                defaultMessage: "Create, assign, and track tasks in real time",
              }),
            },
            {
              icon: <TaskFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-tasks.feature-2",
                defaultMessage: "Set deadlines and priorities",
              }),
            },
            {
              icon: <TaskFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-tasks.feature-3",
                defaultMessage: "Customize fields, statuses, and task types",
              }),
            },
            {
              icon: <TaskFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-tasks.feature-4",
                defaultMessage:
                  "Manage tasks on desktop or mobile with full sync",
              }),
            },
            {
              icon: <TaskFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-tasks.feature-5",
                defaultMessage: "Use templates for repeatable workflows",
              }),
            },
            {
              icon: <TaskFeature6Icon />,
              title: t({
                id: "workspace-features-page.module-info-tasks.feature-6",
                defaultMessage:
                  "View tasks by status, assignee, or custom filters",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl: "https://jugl-assests.jugl.com/learnmorevideos/Tasks.mp4",
        },
        {
          type: "highlights",
          imageUrl: taskHighlightsImage,
        },
      ],
    },

    "Jugl::Chat": {
      title: t({
        id: "workspace-features-page.module-info-chats-and-meetings.title",
        defaultMessage: "Chats & Meetings",
      }),
      titleIcon: <ChatsAndMeetingsTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-chats-and-meetings.description",
            defaultMessage:
              "Stay connected effortlessly with Conference - your all-in-one hub for video calls, audio calls, and chat. Whether you're checking in with a teammate or leading a team-wide meeting, Conference keeps collaboration smooth, secure, and integrated into your workflow.",
          }),
          navigateTo: "chatsChats",
          imageUrl: chatsAndMeetingsInfoImage,
          points: [
            {
              icon: <ChatsAndMeetingsFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-chats-and-meetings.feature-1",
                defaultMessage:
                  "Start video calls, audio calls, or chats with one click",
              }),
            },
            {
              icon: <ChatsAndMeetingsFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-chats-and-meetings.feature-2",
                defaultMessage:
                  "Works seamlessly across desktop and mobile with real-time sync",
              }),
            },
            {
              icon: <ChatsAndMeetingsFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-chats-and-meetings.feature-3",
                defaultMessage:
                  "View full history of calls and chats with timestamps and participants",
              }),
            },
            {
              icon: <ChatsAndMeetingsFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-chats-and-meetings.feature-4",
                defaultMessage:
                  "Instantly pick up recent calls or chats without hunting for links",
              }),
            },
            {
              icon: <ChatsAndMeetingsFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-chats-and-meetings.feature-5",
                defaultMessage:
                  "Everything opens in-app - no third-party tools required",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl: "https://jugl-assests.jugl.com/learnmorevideos/Chats.mp4",
          thumbnailUrl: chatsVideoThumbnailImage,
        },
        {
          type: "highlights",
          imageUrl: chatsAndMeetingsHighlightsImage,
        },
      ],
    },

    "Jugl::People": {
      title: t({
        id: "workspace-features-page.module-info-people.title",
        defaultMessage: "People (Departments and Teams)",
      }),
      titleIcon: <PeopleTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-people.description",
            defaultMessage:
              "Map departments, define roles, and connect the right people to the right responsibilities. With rich profiles, search, and built-in hierarchy, your workspace stays transparent, organized, and ready to scale.",
          }),
          navigateTo: "peoplePeople",
          imageUrl: peopleInfoImage,
          points: [
            {
              icon: <PeopleFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-people.feature-1",
                defaultMessage:
                  "Create detailed member profiles with roles and contact info",
              }),
            },
            {
              icon: <PeopleFeature2Icon />,
              title: t({
                id: "workspace-features-pagemodule-info-people.feature-2",
                defaultMessage:
                  "Group teammates by departments for better organization",
              }),
            },
            {
              icon: <PeopleFeature3Icon />,
              title: t({
                id: "workspace-features-pagemodule-info-people.feature-3",
                defaultMessage:
                  "Assign team tasks based on reporting lines or hierarchy",
              }),
            },
            {
              icon: <PeopleFeature4Icon />,
              title: t({
                id: "workspace-features-pagemodule-info-people.feature-4",
                defaultMessage:
                  "Search profiles to quickly find the right person",
              }),
            },
            {
              icon: <PeopleFeature5Icon />,
              title: t({
                id: "workspace-features-pagemodule-info-people.feature-5",
                defaultMessage:
                  "Set up a Workspace Profile visible to all users",
              }),
            },
            {
              icon: <PeopleFeature6Icon />,
              title: t({
                id: "workspace-features-pagemodule-info-people.feature-6",
                defaultMessage:
                  "Limit editing rights to admins for key team data",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl: "https://jugl-assests.jugl.com/learnmorevideos/People.mp4",
        },
      ],
    },

    "Jugl::Dashboard": {
      title: t({
        id: "workspace-features-page.module-info-dashboard.title",
        defaultMessage: "Dashboard",
      }),
      titleIcon: <DashboardTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-tasks.description",
            defaultMessage:
              "Tasks help you manage everything from simple to-dos to multi-step processes across teams. It’s powerful enough for complex workflows, letting you assign tasks, set deadlines, track progress, and keep work moving without anything slipping through the cracks.",
          }),
          imageUrl: dashboardInfoImage,
          navigateTo: "dashboardDashboard",
          points: [
            {
              icon: <DashboardFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-dashboard.feature-1",
                defaultMessage:
                  "Get a real-time overview of all key activities",
              }),
            },
            {
              icon: <DashboardFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-dashboard.feature-2",
                defaultMessage:
                  "Track progress across tasks, forms, clients, and more",
              }),
            },
            {
              icon: <DashboardFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-dashboard.feature-3",
                defaultMessage:
                  "Customize widgets for what matters to your role",
              }),
            },
            {
              icon: <DashboardFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-dashboard.feature-4",
                defaultMessage:
                  "Create multiple dashboards for different needs",
              }),
            },
            {
              icon: <DashboardFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-dashboard.feature-5",
                defaultMessage:
                  "At-a-glance insights to help you stay focused without context-switching",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Dashboard.mp4",
        },
        {
          type: "highlights",
          imageUrl: dashboardHighlightsImage,
        },
      ],
    },

    "Jugl::WhatsappCrm": {
      title: t({
        id: "workspace-features-page.module-info-crm-inbox.title",
        defaultMessage: "CRM Inbox",
      }),
      titleIcon: <WhatsAppIntegrationTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-whatsapp-integration.description",
            defaultMessage:
              "Connect with customers where they are - automate messages, receive replies, and manage conversations directly inside your workspace. No more switching tabs or missing replies",
          }),
          imageUrl: whatsAppIntegrationInfoImage,
          navigateTo: "clientSupport",
          points: [
            {
              icon: <WhatsAppIntegrationFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-whatsapp-integration.feature-1",
                defaultMessage:
                  "Send automated messages via WhatsApp for tasks, reminders, and updates",
              }),
            },
            {
              icon: <WhatsAppIntegrationFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-whatsapp-integration.feature-2",
                defaultMessage:
                  "Receive and manage customer replies in one central place",
              }),
            },
            {
              icon: <WhatsAppIntegrationFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-whatsapp-integration.feature-3",
                defaultMessage:
                  "Get instant notifications for new replies or missed messages",
              }),
            },
            {
              icon: <WhatsAppIntegrationFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-whatsapp-integration.feature-4",
                defaultMessage:
                  "Schedule WhatsApp messages based on task deadlines or time slots",
              }),
            },
            {
              icon: <WhatsAppIntegrationFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-whatsapp-integration.feature-5",
                defaultMessage:
                  "Attach images, files, or documents directly in chats",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/WhatsappIntegration.mp4",
        },
        {
          type: "highlights",
          imageUrl: whatsAppIntegrationHighlightsImage,
        },
      ],
    },

    "Jugl::OrderForm": {
      title: t({
        id: "workspace-features-page.module-info-forms.title",
        defaultMessage: "Forms",
      }),
      titleIcon: <FormsTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-forms.description",
            defaultMessage:
              "Forms let you collect structured data from clients, teammates, or partners - whether it’s for placing orders, submitting requests, or gathering feedback. Build forms that connect directly to other modules and automate your workflows with ease.",
          }),
          imageUrl: formsInfoImage,
          navigateTo: "orderForms",
          points: [
            {
              icon: <FormsFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-forms.feature-1",
                defaultMessage: "Create custom forms with ease",
              }),
            },
            {
              icon: <FormsFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-forms.feature-2",
                defaultMessage:
                  "Share forms via public link or send them via whatsapp",
              }),
            },
            {
              icon: <FormsFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-forms.feature-3",
                defaultMessage:
                  "Link form submissions to tasks, clients, or invoices",
              }),
            },
            {
              icon: <FormsFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-forms.feature-4",
                defaultMessage: "Duplicate templates for repeatable processes",
              }),
            },
            {
              icon: <FormsFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-forms.feature-5",
                defaultMessage: "Customize branding, labels, and fields",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl: "https://jugl-assests.jugl.com/learnmorevideos/Forms.mp4",
        },
        {
          type: "highlights",
          imageUrl: formsHighlightsImage,
        },
      ],
    },

    "Jugl::Clients": {
      title: t({
        id: "workspace-features-page.module-info-customers.title",
        defaultMessage: "Customers",
      }),
      titleIcon: <CustomersTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-info-customers.description",
            defaultMessage:
              "Clients help you keep all your customer data organized - from contact info and communication history to linked tasks, forms, and invoices. Whether you're managing a few accounts or hundreds, everything you need is just a click away.",
          }),
          imageUrl: customersInfoImage,
          navigateTo: "customersCustomers",
          points: [
            {
              icon: <CustomersFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-customers.feature-1",
                defaultMessage:
                  "Store detailed client profiles and contact information",
              }),
            },
            {
              icon: <CustomersFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-customers.feature-2",
                defaultMessage:
                  "Link clients to tasks, forms, invoices, and more",
              }),
            },
            {
              icon: <CustomersFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-customers.feature-3",
                defaultMessage: "Filter clients by any custom attribute",
              }),
            },
            {
              icon: <CustomersFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-customers.feature-4",
                defaultMessage:
                  "Quickly search and sort through large client lists",
              }),
            },
            {
              icon: <CustomersFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-customers.feature-5",
                defaultMessage: "Add new clients manually or via forms",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Customers.mp4",
        },
        {
          type: "highlights",
          imageUrl: customersHighlightsImage,
        },
      ],
    },

    "Jugl::Reports": {
      title: t({
        id: "workspace-features-page.module-info-reports.title",
        defaultMessage: "Reports",
      }),
      titleIcon: <ScheduledReportsTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-scheduled-reports.description",
            defaultMessage:
              "Reports turns your team’s activity into clear, insightful data - ready to view, share, or export. From task progress to time tracking, it helps you understand what’s working, where time is going, and how to stay on top of everything. Whether you're managing a team or reporting up, it’s reporting made simple.",
          }),
          imageUrl: scheduledReportsInfoImage,
          navigateTo: "reportsScheduled",
          points: [
            {
              icon: <ScheduledReportsFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-scheduled-reports.feature-1",
                defaultMessage:
                  "Generate detailed reports for tasks and time clock entries",
              }),
            },
            {
              icon: <ScheduledReportsFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-scheduled-reports.feature-2",
                defaultMessage: "Export reports in PDF, Excel, or CSV formats",
              }),
            },
            {
              icon: <ScheduledReportsFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-scheduled-reports.feature-3",
                defaultMessage: "Share reports instantly via secure link",
              }),
            },
            {
              icon: <ScheduledReportsFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-scheduled-reports.feature-4",
                defaultMessage:
                  "Customize report fields, views, and date ranges",
              }),
            },
            {
              icon: <ScheduledReportsFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-scheduled-reports.feature-5",
                defaultMessage:
                  "Spot trends in overdue tasks or missed time entries",
              }),
            },
            {
              icon: <ScheduledReportsFeature6Icon />,
              title: t({
                id: "workspace-features-page.module-info-scheduled-reports.feature-6",
                defaultMessage:
                  "See project health at a glance with visual dashboards",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/ScheduledReports.mp4",
        },
        {
          type: "highlights",
          imageUrl: scheduledReportsHighlightsImage,
        },
      ],
    },

    "Jugl::Drive": {
      title: t({
        id: "workspace-features-page.module-info-drive.title",
        defaultMessage: "Drive",
      }),
      titleIcon: <DriveTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-drive.description",
            defaultMessage:
              "Drive is your central, organized space for all files - docs, images, spreadsheets, and more. Whether you're storing internal resources or attaching files to tasks, everything stays accessible, synced, and secure. No more digging through emails or losing track of versions.",
          }),
          imageUrl: driveInfoImage,
          navigateTo: "driveDrive",
          points: [
            {
              icon: <DriveFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-drive.feature-1",
                defaultMessage: "Upload and store files of any type",
              }),
            },
            {
              icon: <DriveFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-drive.feature-2",
                defaultMessage: "Organize files in folders for faster workflow",
              }),
            },
            {
              icon: <DriveFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-drive.feature-3",
                defaultMessage: "Preview files without downloading",
              }),
            },
            {
              icon: <DriveFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-drive.feature-4",
                defaultMessage: "Sync files across desktop and mobile",
              }),
            },
            {
              icon: <DriveFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-drive.feature-5",
                defaultMessage: "Monitor storage usage with visual indicators",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl: "https://jugl-assests.jugl.com/learnmorevideos/Drive.mp4",
        },
        {
          type: "highlights",
          imageUrl: driveHighlightsImage,
        },
      ],
    },

    "Jugl::TravelLog": {
      title: t({
        id: "workspace-features-page.module-info-travel-log.title",
        defaultMessage: "Travel Log",
      }),
      titleIcon: <TravelLogTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-travel-log.description",
            defaultMessage:
              "Travel Log makes it easy to track where your field teams go, how long they stay, and how far they travel. Whether it’s for mileage reporting, verifying time on-site, or managing travel reimbursements, Travel Log keeps everything transparent, automatic, and easy to review.",
          }),
          imageUrl: travelLogInfoImage,
          navigateTo: "travelLogSchedule",
          points: [
            {
              icon: <TravelLogFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-travel-log.feature-1",
                defaultMessage:
                  "Log travel time, distance, and destinations automatically",
              }),
            },
            {
              icon: <TravelLogFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-travel-log.feature-2",
                defaultMessage:
                  "Track field worker movement with GPS-based logging",
              }),
            },
            {
              icon: <TravelLogFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-travel-log.feature-3",
                defaultMessage: "Start and stop trips with a single tap",
              }),
            },
            {
              icon: <TravelLogFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-travel-log.feature-4",
                defaultMessage: "View trip history by user, date, or location",
              }),
            },
            {
              icon: <TravelLogFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-travel-log.feature-5",
                defaultMessage:
                  "Streamlines payroll and field operations tracking",
              }),
            },
            {
              icon: <TravelLogFeature6Icon />,
              title: t({
                id: "workspace-features-page.module-info-travel-log.feature-6",
                defaultMessage: "Easy to use on mobile while on the go",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Travellog.mp4",
        },
        {
          type: "highlights",
          imageUrl: travelLogHighlightsImage,
        },
      ],
    },

    "Jugl::Inventory": {
      title: t({
        id: "workspace-features-page.module-info-catalog.title",
        defaultMessage: "Catalog",
      }),
      titleIcon: <CatalogTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-catalog.description",
            defaultMessage:
              "Inventory helps you keep full control over your products and services - from stock levels to item details. Whether you’re managing physical goods or tracking service availability, it’s all in one place, always up to date, and easy to manage.",
          }),
          imageUrl: catalogInfoImage,
          navigateTo: "inventoryItems",
          points: [
            {
              icon: <CatalogFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-catalog.feature-1",
                defaultMessage: "Add and manage products, services, or bundles",
              }),
            },
            {
              icon: <CatalogFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-catalog.feature-2",
                defaultMessage:
                  "Track stock levels in real time across locations",
              }),
            },
            {
              icon: <CatalogFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-catalog.feature-3",
                defaultMessage:
                  "Log inventory movements - additions, usage, returns",
              }),
            },
            {
              icon: <CatalogFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-catalog.feature-4",
                defaultMessage:
                  "Add photo and description to product profiles for easier item management ",
              }),
            },
            {
              icon: <CatalogFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-catalog.feature-5",
                defaultMessage:
                  "Sync inventory updates with mobile app users in the field",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Inventory.mp4",
        },
        {
          type: "highlights",
          imageUrl: catalogHighlightsImage,
        },
      ],
    },

    "Jugl::AI_Agents": {
      title: t({
        id: "workspace-features-page.module-info-ai-workflows.title",
        defaultMessage: "AI Workflows",
      }),
      titleIcon: <AIAgentsTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-ai-workflows.description-2",
            defaultMessage:
              "AI Workflows give you smarter, faster work management with real-time feedback, intelligent insights, and employee evaluation. Whether you're analyzing performance, drafting detailed task flows, or unblocking team workflows, AI Workflows help you work more efficiently and stay on top of what matters.",
          }),
          imageUrl: aIAgentsInfoImage,
          navigateTo: "dashboardDashboard",
          points: [
            {
              icon: <AIAgentsFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-ai-agents.feature-1",
                defaultMessage:
                  "Instantly rate task performance to spot what’s working and what’s not",
              }),
            },
            {
              icon: <AIAgentsFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-ai-agents.feature-2",
                defaultMessage:
                  "Drafts detailed task steps from notes or chat input",
              }),
            },
            {
              icon: <AIAgentsFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-ai-agents.feature-3",
                defaultMessage:
                  "Identify priority tasks and workflow bottlenecks in real-time",
              }),
            },
            {
              icon: <AIAgentsFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-ai-agents.feature-4",
                defaultMessage:
                  "Automate repetitive workflow actions and follow-ups",
              }),
            },
            {
              icon: <AIAgentsFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-ai-agents.feature-5",
                defaultMessage:
                  "Ensure process consistency and reduce missed steps across teams",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/AIAgents.mp4",
          thumbnailUrl: aIAgentsVideoThumbnailImage,
        },
        {
          type: "highlights",
          imageUrl: aIAgentsHighlightsImage,
        },
      ],
    },

    "Jugl::Integration": {
      title: t({
        id: "workspace-features-page.module-info-integrations.title",
        defaultMessage: "Integrations",
      }),
      titleIcon: <IntegrationsTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-integrations.description-2",
            defaultMessage:
              "Connect your favorite tools and streamline your  workflow with seamless integrations. Sync data, automate tasks, and keep everything in perfect harmony across your entire tech stack.",
          }),
          imageUrl: integrationsInfoImage,
          navigateTo: "integrations",
          points: [
            {
              icon: <IntegrationsFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-integrations.feature-1",
                defaultMessage:
                  "Connect with 200+ popular apps and services instantly",
              }),
            },
            {
              icon: <IntegrationsFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-integrations.feature-2",
                defaultMessage:
                  "Set up automated workflows without writing code",
              }),
            },
            {
              icon: <IntegrationsFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-integrations.feature-3",
                defaultMessage: "Real-time data sync across all your platforms",
              }),
            },
            {
              icon: <IntegrationsFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-integrations.feature-4",
                defaultMessage:
                  "Enterprise-grade security with encrypted connections",
              }),
            },
            {
              icon: <IntegrationsFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-integrations.feature-5",
                defaultMessage:
                  "Ingest external data into workflows for smarter, context-aware decisions",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Integration.mp4",
        },
        {
          type: "highlights",
          imageUrl: integrationsHighlightsImage,
        },
      ],
    },

    "Jugl::Invoice": {
      title: t({
        id: "workspace-features-page.module-invoices.title2",
        defaultMessage: "Invoices",
      }),
      titleIcon: <InvoicesTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-invoices.description",
            defaultMessage:
              "Invoices help you quickly generate professional invoices based on your existing orders. It streamlines the billing process, reduces manual work, and keeps your financial documents organized and accessible in one place.",
          }),
          imageUrl: invoicesInfoImage,
          navigateTo: "invoices",
          points: [
            {
              icon: <InvoicesFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-invoices.feature-1",
                defaultMessage:
                  "Create invoices directly from submitted orders",
              }),
            },
            {
              icon: <InvoicesFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-invoices.feature-2",
                defaultMessage: "Customize invoice fields, and branding",
              }),
            },
            {
              icon: <InvoicesFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-invoices.feature-3",
                defaultMessage: "Track payment status and due dates",
              }),
            },
            {
              icon: <InvoicesFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-invoices.feature-4",
                defaultMessage: "Automatically calculate taxes and totals",
              }),
            },
            {
              icon: <InvoicesFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-invoices.feature-5",
                defaultMessage: "Send invoices via email with one click",
              }),
            },
            {
              icon: <InvoicesFeature6Icon />,
              title: t({
                id: "workspace-features-page.module-info-invoices.feature-5",
                defaultMessage:
                  "Filter invoices by client, status, or time range",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Invoices.mp4",
        },
        {
          type: "highlights",
          imageUrl: invoicesHighlightsImage,
        },
      ],
    },

    "Jugl::Automation": {
      title: t({
        id: "workspace-features-page.module-info-automation.title",
        defaultMessage: "Automation",
      }),
      titleIcon: <AutomationTitleIcon />,
      steps: [
        {
          type: "info",
          description: t({
            id: "workspace-features-page.module-integrations.description-2",
            defaultMessage:
              "Connect your favorite tools and streamline your  workflow with seamless integrations. Sync data, automate tasks, and keep everything in perfect harmony across your entire tech stack.",
          }),
          imageUrl: automationInfoImage,
          navigateTo: "dashboardDashboard",
          points: [
            {
              icon: <AutomationFeature1Icon />,
              title: t({
                id: "workspace-features-page.module-info-automation.feature-1",
                defaultMessage:
                  "Create smart workflows with if-then logic and conditions",
              }),
            },
            {
              icon: <AutomationFeature2Icon />,
              title: t({
                id: "workspace-features-page.module-info-automation.feature-2",
                defaultMessage:
                  "Schedule tasks to run automatically at specific times",
              }),
            },
            {
              icon: <AutomationFeature3Icon />,
              title: t({
                id: "workspace-features-page.module-info-automation.feature-3",
                defaultMessage:
                  "Set up smart notifications and alerts for important events",
              }),
            },
            {
              icon: <AutomationFeature4Icon />,
              title: t({
                id: "workspace-features-page.module-info-automation.feature-4",
                defaultMessage: "Automate data entry and form processing tasks",
              }),
            },
            {
              icon: <AutomationFeature5Icon />,
              title: t({
                id: "workspace-features-page.module-info-automation.feature-5",
                defaultMessage:
                  "Generate reports automatically on custom schedules",
              }),
            },
            {
              icon: <AutomationFeature6Icon />,
              title: t({
                id: "workspace-features-page.module-info-automation.feature-5",
                defaultMessage:
                  "Track automation performance with detailed insights",
              }),
            },
          ],
        },
        {
          type: "video",
          videoUrl:
            "https://jugl-assests.jugl.com/learnmorevideos/Automation.mp4",
          thumbnailUrl: automationVideoThumbailImage,
        },
        {
          type: "highlights",
          imageUrl: automationHighlightsImage,
        },
      ],
    },
  };
  return modulesData;
};
